@let isEditable = isStatusEditable();
@if (taskStatuses[status()]; as title) {
  <div
    class="status-dropdown"
    [class]="status()"
    [class.readonly]="!isEditable"
    [matMenuTriggerFor]="isEditable ? statusMenu : null"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
    (click)="onStatusClick($event)"
    #statusTrigger="matMenuTrigger">
    <span class="status-wrap" [class]="status()">
      {{ title | translate }}
    </span>
    <mat-icon class="dropdown-arrow" [class.rotated]="isMenuOpenState()">
      keyboard_arrow_down
    </mat-icon>
  </div>
  <mat-menu #statusMenu="matMenu">
    @for (statusOption of statusMenuOptions; track statusOption) {
      <button
        mat-menu-item
        (click)="onStatusChange(statusOption)"
        [class.active]="status() === statusOption">
        <span>{{ taskStatuses[statusOption] | translate }}</span>
      </button>
    }
  </mat-menu>
} @else {
  <span>{{ status() || '-' }}</span>
}
